export enum MapVisualType {
    Street = "street",
    Satellite = "satellite",
}
